module.exports = __webpack_public_path__ + "static/media/box-shell.6bba64aa.svg";